/* eslint-disable react/prop-types */
import React from 'react';
import CartContext from "./CartContext";
const withCart = WrappedComponent=>{
  class Comp extends React.PureComponent{
    constructor(props){
      super(props);
      this.state={}
    }
    render(){
      const {cartRef, ...rest} = this.props;
      return <WrappedComponent ref={cartRef} {...rest} {...this.context}/>
    }
  }
  Comp.contextType = CartContext
  return Comp
}
export default withCart;
